// Angular
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// Services
import { IdleService } from './../../services/idle/idle.service';

@Component({
  selector: 'oh-guest-idle',
  templateUrl: './guest-idle.component.html',
  styleUrls: ['./guest-idle.component.scss'],
})
export class GuestIdleComponent {
  public countdown: number;

  constructor(private idleService: IdleService, private dialog: MatDialog) {
    this.idleService.resetCountdown$.subscribe((value) => {
      this.countdown = value;
    });
  }

  public close() {
    this.idleService.resetTimer();
    this.dialog.closeAll();
  }
}
